// LocContext.MESSAGES
// prettier-ignore
export default {
  // business-components/mailboxMessages/MessageBackButton.tsx
  "a9b171053582": "Tilbake",

  // business-components/mailboxMessages/MessageDesktopCard.tsx
  "f23c5904c559": "Postkasse",

  // business-components/mailboxMessages/MessageMobileCard.tsx
  "0eb885254e82": "Innboks",
  "fab02036e548": "Utboks",
  "376eb3fcd572": "Melding",
  "d94bc97a659d": "Ny melding",
  "da9a67ea7585": "Svar på melding",

  // business-components/messages/DeleteRequestedMessage.tsx
  "c05f8e8495e1": "Du har bedt om å bli slettet den {0}. Det tar litt tid før forespørselen blir behandlet. Det er {1} som utfører slettingen. Når du ikke lenger kan logge inn har dataene dine blitt slettet. Ta kontakt med {1} hvis du har spørsmål.",

  // business-components/messages/EmailVerificationMessage.tsx
  "fb8f7e9698f1": "Send ny e-post",
  "955a35071b36": "E-post verifisert",
  "6c733c6a3484": "E-post er ikke verifisert.",
  "32fcd2cfabf9": "E-post venter på verifisering.",
  "dcccaaf50733": "E-post er ikke verifisert. Verifiserings e-post er utløpt, vennligst be om ny.",
  "13cd92fe9160": "E-postendring venter på verifisering.",
  "29abf33f003a": "E-post er sendt",
  "cabc4f40ac24": "E-post er sendt",

  // business-components/messages/MissingConsentMessage.tsx
  "bed2f6e2f33d": "Vi mangler ditt samtykke",
  "02def82839c6": "Se samtykker",

  // business-components/messages/MissingInfoMessage.tsx
  "b81d3acabbf7": "Vi mangler viktig informasjon om deg:",
  "1939854228d7": "og",

  // business-components/messages/PhoneVerificationMessage.tsx
  "6c50859b6c13": "Send ny sms",
  "78a10c7942a9": "Telefonnummer er verifisert.",
  "f674d2ddbdb1": "Telefonnummer er ikke verifisert.",
  "85747116a8d5": "Telefonnummer venter på verifisering.",
  "d1a9cb8eae40": "Telefonnummer er ikke verifisert. Verifiserings SMS er utløpt, vennligst be om ny.",
  "1f86818b2c53": "Endret telefonnummer venter på verifisering.",
  "a771232cb3fc": "SMS er sendt",
  "9688a301f4b5": "SMS er sendt",

  // business-components/forms/messages/ForwardMessageForm.tsx
  "84a598140901": "Melding er sendt!",
  "dfe74eaeed12": "Forkaste melding",
  "abf721f7064f": "Er du sikker på at du vil forkaste meldingen?",
  "de602bf60ff1": "Til:",
  "eb767e46c636": "Emne:",
  "61d396b1b891": "Emne",
  "3cf2a296b9ee": "Melding",
  "e9688ceefe98": "Melding",
  "57d82bb4272f": "Forkast",
  "1e939ec450f1": "Send melding",

  // business-components/forms/messages/messageValidationSchemas.ts
  "9b304a15b58a": "Mottaker er påkrevd",
  "dd0d689a87d5": "Venligst bruk kun bokstaver, tall og punkterings tegn",
  "8e055411ab85": "Emne er påkrevd",
  "114457f48647": "Melding er påkrevd",
  "9ab2883e90be": "Venligst bruk kun bokstaver, tall og punkterings tegn",
  "2482bba603cd": "Emne er påkrevd",
  "aaf05156e71b": "Melding er påkrevd",

  // business-components/forms/messages/NewMessageForm.tsx
  "7cae35b3ea66": "Melding er sendt!",
  "944ddd2c2ccd": "Forkaste melding",
  "ac42b17dc9ca": "Er du sikker på at du vil forkaste meldingen?",
  "246649fe8bb5": "Til:",
  "362cd665b8f2": "Emne:",
  "0020ef98446a": "Emne",
  "068afefbb876": "Melding",
  "86d3c6e5a130": "Melding",
  "433309804ac7": "Forkast",
  "81cb08cf97f2": "Send melding",

  // business-components/forms/messages/ReplyMessageForm.tsx
  "b66fc2e87483": "Melding er sendt!",
  "d3fa70c4d750": "Forkaste melding",
  "e890a7ff2670": "Er du sikker på at du vil forkaste meldingen?",
  "1cfaf4bf7bb6": "Til:",
  "9c2d505fce10": "Emne:",
  "ba539ba3bf14": "Emne",
  "ffaa99243a96": "Melding",
  "f6c44ac86491": "Melding",
  "43c437ab6e1d": "Forkast",
  "8253086721c4": "Send melding",

  // business-components/mailboxMessages/MessageContent/AcceptDeclineButtons.tsx
  "a7841c0980e9": "Bekrefte innhold",
  "62df670976e3": "Er du sikker på at du vil bekrefte innholdet i meldingen? Svaret kan ikke endres.",
  "f2969f135637": "Avvis innhold",
  "909c33a31a87": "Er du sikker på at du vil avvis innholdet i meldingen? Svaret kan ikke endres.",
  "c6752a315c71": "Bekreft",
  "1ef90ed88bbd": "Avslå",

  // business-components/mailboxMessages/MessageContent/MessageAttachmentInfo.tsx
  "06dbd580a635": "Kunne ikke laste ned vedlegget",

  // business-components/mailboxMessages/MessageContent/MessageButtons.tsx
  "095236040fc9": "Du må lese vedlegget før du kan bekrefte eller avslå",
  "9cec819ea9a4": "Du må lese vedleggene før du kan bekrefte eller avslå",
  "788de2f2e6eb": "Innholdet i meldingen er bekreftet",
  "6d2ca0dcf532": "Innholdet i meldingen er avvist",
  "851a4bc1250f": "Svar",
  "087b7ff7cb24": "Lukk",

  // business-components/mailboxMessages/MessageContent/MessageInfo.tsx
  "cb9af6b8c2f4": "Dato:",
  "426a4020ed83": "Til:",
  "3f059e5803f0": "Fra:",
  "4660e6b9f44d": "Emne:",

  // business-components/mailboxMessages/MessageContent/NoMessage.tsx
  "394734168bf0": "Du har ikke sendt noen meldinger.",
  "909a6e6aeb62": "Du har ikke mottatt noen meldinger.",

  // business-components/mailboxMessages/MessageContent/PhoneOrEmailVerificationMissing.tsx
  "2e45deeb723e": "Du kan ikke se eller sende meldinger før du har verifisert e-posten og telefonnummeret ditt.",
  "099207095dad": "Du kan ikke se eller sende meldinger før du har verifisert telefonnummeret ditt.",
  "52a4a60d7a6e": "Du kan ikke se eller sende meldinger før du har verifisert e-posten din.",
  "94288b048981": "Refresh siden",

  // business-components/mailboxMessages/MessageTabView/index.tsx
  "fd74f4d91579": "Innboks",
  "b6926ffa24fe": "Utboks",

  // business-components/mailboxMessages/NewMessage/NewMsgBtn.tsx
  "f65a8e096d88": "Ny melding",

  // business-components/mailboxMessages/NewMessage/SendRemoveButtons.tsx
  "b5321a7ef55c": "Send",
  "e955375cb2ba": "Forkast",

  // business-components/mailboxMessages/MessageTabView/Inbox/index.tsx
  "c8831b68139c": "Fra:",

  // business-components/mailboxMessages/MessageTabView/Outbox/index.tsx
  "633ccafe56b5": "Til:",
}